<template>
    <div>
        <myHeader></myHeader>
        <aboutNav></aboutNav>
        <div class="about_page">
            <div class="about_page_nr" v-html="about" v-if="about"></div>
            <el-empty :image-size="160" v-else></el-empty>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../../components/header.vue'
import MyFooter from '../../components/footer.vue'
import aboutNav from '../../components/about_nav.vue'
export default {
    name: 'about',
    components: {MyFooter, myHeader,aboutNav},
    data () {
        return {
            about:'',
            siteInfo:''
        }
    },
    created () {
        this.pageData();
        this.pageSiteMsg();
    },
    methods: {
        pageData () {
            this.$api.aboutUs().then(res => {
                this.about = res.data;
            });
        },
        pageSiteMsg () {
            this.$api.siteMsg().then(res => {
                this.siteInfo = res.data.siteMsg;
            });
        },
    }
}
</script>

<style>
.about_page{width:100%;height:auto;min-height:200px;float:left;background:#fff;padding:50px 0 60px;}
.about_page_nr{width:1200px;height:auto;min-height:200px;float:left;position:relative;left:50%;margin-left:-600px;
    margin-top:0;font-size:14px;color:#333;line-height:24px;}
.process{width:100%;height:auto;float:left;}
.process img{width:100%;height:auto;float:left;}
.about_img{width:460px;height:314px;display:inline-block;float:left;}
.about_text{width:740px;height:auto;float:left;padding-left:40px;padding-top:50px;display:inline-block;font-size:18px;line-height:30px;}
.about_nr{width:100%;height:auto;float:left;}
.about_page_nr .about_nr:nth-child(2){margin-top:30px;}
.about_page_nr .about_nr:nth-child(2) .about_text{padding-left:0;padding-right:40px;}
@media (min-width:992px) and (max-width:1200px){
    .about_page{min-height:200px;padding:40px 0 50px;}
    .about_page_nr{width:1000px;min-height:200px;margin-left:-500px;font-size:14px;line-height:24px;}
    .about_img{width:360px;height:245px;}
    .about_text{width:640px;padding-left:30px;padding-top:40px;font-size:16px;line-height:26px;}
    .about_page_nr .about_nr:nth-child(2){margin-top:25px;}
    .about_page_nr .about_nr:nth-child(2) .about_text{padding-right:30px;}
}
@media (min-width:768px) and (max-width:991px){
    .about_page{min-height:200px;padding:30px 0 40px;}
    .about_page_nr{width:750px;min-height:200px;margin-left:-375px;font-size:14px;line-height:24px;}
    .about_img{width:300px;height:205px;}
    .about_text{width:450px;padding-left:20px;padding-top:10px;font-size:14px;line-height:20px;}
    .about_page_nr .about_nr:nth-child(2){margin-top:20px;}
    .about_page_nr .about_nr:nth-child(2) .about_text{padding-right:20px;}
}
@media (max-width:767px){
    .about_page{min-height:200px;padding:20px 15px 30px;}
    .about_page_nr{width:100%;min-height:200px;margin-left:0;left:0;font-size:14px;line-height:24px;}
    .about_img{width:100%;height:auto;}
    .about_text{width:100%;padding-left:0;padding-top:10px;font-size:14px;line-height:20px;}
    .about_page_nr .about_nr:nth-child(2){margin-top:10px;}
    .about_page_nr .about_nr:nth-child(2) .about_text{padding-right:0;padding-bottom:10px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue